import { status_dot_class as shared_status_dot_class } from '@/views/x-verdict_views/CaseOwner/AllCases/case_state';
import {
  normalize_text,
  to_number,
} from './company_cases_common';

export function format_case_code(record = {}) {
  const application_id = to_number([
    record?.application_id,
    record?.latest_application_id,
    record?.current_application_id,
  ].find(Boolean));
  const entity_profile_id = to_number([record?.entity_profile_id, record?.id].find(Boolean));
  const case_codes = [
    record?.reference_number,
    record?.case_code,
    record?.reference,
    record?.code,
    application_id ? `C-${application_id}` : '',
    entity_profile_id ? `EP-${entity_profile_id}` : '',
    'C-new',
  ];
  return normalize_text(case_codes.find(Boolean));
}

export function format_title(record = {}, domain = 'Case') {
  const titles = [
    record?.entity_name,
    record?.name,
    record?.profile_name,
    record?.title,
    record?.description,
    `${domain} case`,
  ];
  return normalize_text(titles.find(Boolean));
}

export function record_created_date(record = {}) {
  return [
    record?.date_created,
    record?.created_at,
    record?.application_date_created,
    record?.opened_at,
    record?.submitted_on,
  ].find(Boolean);
}

export function format_date(value) {
  if (!value) return '';

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return normalize_text(value);

  return date.toLocaleDateString('en-ZA', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function format_subtitle(record = {}) {
  const opened = format_date(record_created_date(record));
  const details = [
    [record?.requester, record?.requestor, record?.claimant, record?.created_by_name].find(Boolean),
    [record?.policy_number, record?.reference_number, record?.external_reference].find(Boolean),
    [record?.value, record?.claim_value, record?.amount].find(Boolean),
    opened ? `Opened ${opened}` : '',
  ];
  return details.map(normalize_text).filter(Boolean).join(' - ') || 'Opened date unavailable';
}

export function domain_badge_class(domain_key = '') {
  return domain_key
    ? 'bg-primary-subtle text-primary-emphasis'
    : 'bg-secondary-subtle text-secondary-emphasis';
}

export function status_dot_class(status = '') {
  return shared_status_dot_class(status);
}
